import React from 'react';
export function AuthoritySection() {
  return <section className="w-full bg-white py-8 px-4 border-t border-gray-200" data-id="element-18">
      <div className="max-w-2xl mx-auto" data-id="element-19">
        <h2 className="text-3xl md:text-4xl font-black text-center text-black mb-8" data-id="element-20">
          Antes vs Después
        </h2>

        <div className="flex flex-col md:flex-row gap-8" data-id="element-21">
          <div className="flex-1 border-l-4 border-red-500 pl-6" data-id="element-22">
            <p className="text-2xl font-black text-red-600 uppercase mb-6" data-id="element-23">
              Antes
            </p>
            <ul className="space-y-3 text-lg font-bold text-gray-800" data-id="element-24">
              <li data-id="element-25">❌ discusiones al hacer tareas</li>
              <li data-id="element-26">❌ frustración constante</li>
              <li data-id="element-27">❌ no saber cómo explicar</li>
              <li data-id="element-28">❌ culpa como padre/madre</li>
            </ul>
          </div>

          <div className="flex-1 border-l-4 border-green-500 pl-6" data-id="element-29">
            <p className="text-2xl font-black text-green-600 uppercase mb-6" data-id="element-30">
              Después
            </p>
            <ul className="space-y-3 text-lg font-bold text-gray-800" data-id="element-31">
              <li data-id="element-32">✓ más calma en casa</li>
              <li data-id="element-33">✓ claridad para acompañar</li>
              <li data-id="element-34">✓ mejor conexión con tu hijo</li>
              <li data-id="element-35">✓ confianza en lo que estás haciendo</li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}